import { call, put, takeLatest } from 'redux-saga/effects';
import { requestHTML, TRIGGERNEXTOVERLAY } from '@vfde-fe/sails_core';
import { loadScript, loadStyleSheet } from './helper/loadExternalScripts';
import {
    INSURANCE_ACCORDION,
    INSURANCE_OVERLAY_NAME,
    PRELOAD_GIGAKOMBI_OVERLAY,
    TAUSCHBONUS_OVERLAY_NAME,
    TRADEIN_ACCODRION,
    TRADE_IN_OVERLAY_NAME,
} from './constant';
import { mountOverlayAccordion, showOverlay } from './components/Overlay';
import { getOverlayContentFailed, overlayLoaded } from './action';
import { trackTradeInOverlay } from 'Helper/tracking';

/**
 * Gets the content of the overlay and populates it
 *
 * @export {function} getOverlayContent
 *
 */
export function* getOverlayContent (action) {
    const { url, name } = action;

    if (!url) {
        return;
    }

    try {
        const response = yield call(requestHTML, url, {});
        yield call(showOverlay, response);
        yield put(overlayLoaded());

        switch (name) {
            case INSURANCE_OVERLAY_NAME:
                yield call(mountOverlayAccordion, INSURANCE_ACCORDION);
                break;
            case TAUSCHBONUS_OVERLAY_NAME:
                yield call(mountOverlayAccordion, TRADEIN_ACCODRION);
                break;
            case TRADE_IN_OVERLAY_NAME:
                yield call(trackTradeInOverlay);
                break;
        }
    } catch (err) {
        yield put(getOverlayContentFailed(err));
    }
}

/**
 * preloadGigaKombiOverlay
 */
export function* preloadGigaKombiOverlay (action) {
    const { contentTarget, scriptTarget } = action;
    const options: any = {};
    const htmlMarkup = yield call(requestHTML, window.additionalPageOptions.gigakombi.offerPrice.gigakombiOverlay, options);
    contentTarget.innerHTML = `<div>${htmlMarkup}</div>`;

    // Scripts are generated in gigakombiXSell repo
    loadScript('/simplicity/assets/js/sails.gigakombi-xsell-mobile.js', scriptTarget);
    loadStyleSheet('/simplicity/assets/css/sails.gigakombi-xsell-mobile.css', scriptTarget);
}

/**
 * Waits for TRIGGERNEXTOVERLAY action from core to call getAPI
 *
 * @export {function} overlaySaga
 *
 */
export default function* overlaySaga () {
    yield takeLatest(TRIGGERNEXTOVERLAY, getOverlayContent);
    yield takeLatest(PRELOAD_GIGAKOMBI_OVERLAY, preloadGigaKombiOverlay);
}
